import React, { FC, useCallback } from 'react'
import './index.scss'
import { useTranslation } from 'react-i18next'

interface StatusProps {
  statusValue: string
  statusType: string
  className?: string,
  text?: string
}

export const TransferStatus: FC<StatusProps> = ({

  statusType,
  statusValue,
}) => {
  const {t} = useTranslation()
  const renderIcon = useCallback(() => {
    switch (statusType) {
      case 'BATCH_CHECK_WAITING':
        return 'transfer-status__type--waiting'
      case 'BATCH_CHECK_ERROR':
        return 'transfer-status__type--errored'
      case 'BATCH_PAYMENTERROR':
          return 'transfer-status__type--errored'
      case 'BATCH_CHECK_START':
        return 'transfer-status__type--pending'
      case 'BATCH_WAITING_CREATE':
        return 'transfer-status__type--waitedForCreating'
      case 'BATCH_START_CREATE':
        return 'transfer-status__type--creating'
      case 'BATCH_FORPAYMENT':
        return 'transfer-status__type--created'
      case 'PENDING_SIGNER':
          return 'transfer-status__type--wforSign'
      case 'BANK_SUCCESS':
            return 'transfer-status__type--created'
      case 'EXPIRED' || 'PENDING_ALL'|| "BANK_ERROR"||"BANK_SUCCESS"|| "SEND_TO_BANK" || "CLOSED"||"BANK_REJECTED" ||"DELETED"||"EDITED"||"PENDING_APPROVER":
            return 'transfer-status__type--wforSign'
      default:
        return null
    }
  }, [statusType])

  const renderText = useCallback(() => {
    switch (statusValue?.toString()) {
      case 'BATCH_CHECK_WAITING':
        return t('transfers.waitingForVerification')
      case 'BATCH_CHECK_ERROR':
        return t("transfers.errorsDetectedChecking")
      case 'BATCH_PAYMENTERROR':
          return t("transfers.errorsCreating")
      case 'BATCH_CHECK_START':
        return  t("transfers.checking")
      case 'BATCH_WAITING_CREATE':
        return t("transfers.waitingForCreation")
      case 'BATCH_START_CREATE':
        return 'Köçürmələr"-də yaradılır'
      case 'BATCH_FORPAYMENT':
        return t('transfers.CreatedTransfers')
      // case 'PENDING_SIGNER':
      //     return  t("transfers.forSigning") 
      case 'BANK_SUCCESS':
            return t("transfers.sentToBank") 
      case 'EXPIRED':
              return t("transfers.expired")
              case 'CLOSED':
                return t("transfers.executed")
              case 'PENDING_SIGNER':
                return   t("transfers.forSigning")
              case 'PENDING_APPROVER':
                return   t("transfers.forConfirmation")
              case 'PENDING_ALL':
                return   t("transfers.signConfirmation")
              case 'SEND_TO_BANK':
                return   t("transfers.inProcess")
              case 'BANK_ERROR':
                return   t("transfers.notProcessed")
              case 'BANK_SUCCESS':
                return   t("transfers.sentToBank")
              case 'BANK_REJECTED':
                return   t("transfers.rejected")
              case 'XV':
                return   t("home.foreignCurrencyTransfer")
              case 'DELETED':
                return   t("transfers.deleted")    
      default:
        return null
    }
  }, [statusValue])
  return (
    <div className={`transferStatus flex`}>
      <div className='circle' style={{minWidth: 20}}><span className={`transfer-status__type ${renderIcon()}`} /></div>
      <span className={'transfer-status__text'}>{renderText()}</span>
    </div>
  )
}
